<ng-template #statWidgets>
  <div class="stat-content flex-grow-1 w-100">
    <div class="row g-3 m-0 stat-row-no-gutter">
      @for (stat of statData; track $index) {
        <div
          class="stat-box flex-grow-1 d-flex"
          [class.d-none]="isOtherClass && stat.widgetName===widgetNameSameType"
          [ngStyle]="{
            'min-width': statBoxMinWidth,
            flex: '1 1 calc(100% / ' + maxWidgetsPerRow + ' - 1rem)'
          }"
        >
          <app-stat-tile
            class="flex-grow-1 h-100"
            [accentColour]="stat.iconColour ?? 'primary'"
            [caption]="stat.subTitle"
            [decimalPlaces]="stat.decimalPlaces ?? 0"
            [icon]="'bx ' + stat.icon"
            [label]="stat.title ?? ''"
            [loading]="stat.loading"
            [selectable]="true"
            [trendPercent]="trendPercent(stat)"
            [trendUpIsGood]="stat.profitUpIsGood ?? true"
            [value]="stat.value ?? null"
            (tileClick)="onWidgetClick(stat)"
          ></app-stat-tile>
        </div>
      }
    </div>
  </div>
</ng-template>

@if (useContainer) {
  @if (visibleContainer) {
    <div class="row" [ngClass]="marginBottom">
      <div class="col-12">
        <div class="border border-success rounded ss-grey-panel">
          <div class="row">
            <div class="col-12">
              <div
                class="alert border-0 alert-primary d-flex justify-content-between align-items-center mb-0"
                role="alert"
              >
                <div class="d-flex align-items-center" style="gap: 8px;">
                  <strong>{{containerTitle}}</strong>
                  <span *ngIf="previousSync && syncInfoText" class="text-muted" style="font-size: 0.85em;">- {{syncInfoText}}</span>
                </div>

                <div class="d-flex align-items-center" style="gap: 6px;">
                  @if (userDomains) {
                    <span class="badge bg-success-subtle text-success fs-11 d-inline-flex align-items-center gap-1">
                      <i class="ri-filter-3-line"></i>
                      Filtered to {{ userDomainsText }}
                      <button class="btn btn-link btn-sm p-0 ms-1 text-primary lh-1" title="Clear the user domain filter" type="button" (click)="userDomainsClear.emit()"><i class="ri-close-line"></i></button>
                    </span>
                  }
                  <button *ngIf="actionButton0Show"
                    type="button"
                    class="btn btn-sm btn-outline-primary rounded-pill"
                    (click)="actionButton0OnClick()"
                  >
                    {{actionButton0Text}}
                  </button>

                  <span
                    *ngIf="!expandContainer && showTitleHintText"
                    class="text-muted"
                    style="font-size: 0.85em;"
                  >
                    Widget Row
                  </span>
                  <i class="fs-5"
                     [attr.data-bs-toggle]="'tooltip'"
                     [attr.data-bs-title]="expandContainer ? 'Collapse' : 'Expand'"
                     [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                     style="cursor: pointer; color: #198754;"
                     (click)="toggleContainerExpansion()">
                  </i>
                  <i *ngIf="allowContainerClose"
                     class="fs-3 bx bx-x"
                     [attr.data-bs-toggle]="'tooltip'"
                     data-bs-title="Close"
                     style="cursor: pointer; color: #dc3545;"
                     (click)="closeContainer()">
                  </i>
                </div>
              </div>
            </div>
          </div>
  
          @if (expandContainer) {
            <div class="row">
              <div class="col-12">
                <div class="mb-2 w-100">
                  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
}
